var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',_vm._b({attrs:{"use-utc":true,"input-class":"input"},on:{"input":_vm.onChanged},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'datepicker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }